<template>
    <wrapper>
        <div class="center" v-if="loading">
            <pre-loader></pre-loader>
        </div>
        <div class="container" v-else>
            <fragment v-if="!data.already_taken">
                <div class="center" style="margin-top:20px;">
                <h5>{{ data.subject.name }}</h5>
                
                </div>
                <div class="card" style="margin-top:20px;">
                    <div class="card-header" style="padding:5px;padding-left:20px;">
                        <p>Choose one of the options in the following questions</p>
                        <p class="red-text">Don't click back button or reload the page. All of your answers will be reset</p>
                    </div>
                    <div class="card-content" style="padding-bottom:50px;">
                        <data-row @optionChange="chooseOption" v-for="(item,index) in data.question_group.questions" :data="item" :index="index"></data-row>
                        
                    </div>
                    <div class="card-actions" style="padding-bottom:10px;text-align:center;">
                        <p class="red-text">Please check all the answers. You will not able to change anything after submitting</p>
                        <loading-btn 
                                        v-if="finish==false"
                                        v-bind:button_type="'submit'"
                                        v-bind:text="'Submit'"
                                        v-bind:loading="action_loading"
                                        v-bind:custom_class="'btn'"
                                        @button_click="submitAnswer"
                                    ></loading-btn>
                    </div>
                </div>
                <result v-if="showResultModal" @finish="$router.push('/home')"></result>
            </fragment>
            <div v-else>
                <div class="result_box">
                    <div class="card card-content">
                        <h5 class="red-text">You have already finished the exam</h5><br/>
                         <a class="btn pink darken-2">Click here to view your result</a>
                        <a class="btn blue darken-2" style="margin-left:50px;">Click here to send result to your email</a></br><br/>
                        <router-link to="/home" class="btn">Back</router-link></br><br/>
                    </div>
                </div>
            </div>
            
        </div>
    </wrapper>
</template>
<script>
import DataRow from '@/components/Exam/DataRow.vue';
import Result from '@/components/Exam/Result';
import { createFormData } from './../../misc/CreateFormData.js';
export default {
    data()
    {
        return {
            answers:[],
            showResultModal:false,
        }
    },
    
    components: 
    {
        "data-row":DataRow,
        "result":Result,
    },
    mounted() {
        this.$store.dispatch("get_exam",{id:this.$route.params.id});
  
    },
    
  
    computed: {
        loading()
        {
            return this.$store.getters.exam_loading;
        },
        action_loading()
        {
            return this.$store.getters.exam_answer_loading;
        },
        data()
        {
            return this.$store.getters.each_exam;
        },
        finish()
        {
            return this.$store.getters.exam_finish;
        }
    },
    
    watch: 
    {
        finish(val)
        {
            if (val)
            {
                this.showResultModal=true;
            }
        },
        
            
    },
    methods: {
        chooseOption(data)
        {
            
            if (this.checkInAnswers(data.question_id))
            {
                
                this.answers=this.answers.filter((value)=>{
                    return value.question_id!=data.question_id;
                });
            }
            
            
                this.answers.push(data);
            
        },
        checkInAnswers(question_id)
        {
            
            var result=false;
            this.answers.map((value)=>{
                
                if (parseInt(value.question_id)==parseInt(question_id))
                {
                    result=true;
                }
            });
            return result;
        },
        submitAnswer()
        {
            this.$store.dispatch("answer_exam",createFormData({
                "exam_id":this.$route.params.id,
                "question_group_id":this.data.question_group_id,
                "answers":JSON.stringify(this.answers)
            }));
        },
      
    },
}
</script>
<style lang="scss">
    .result_box
    {
        margin-top:150px;

    }

     .result_box .card 
     {
         padding:50px;
         border-radius:30px;
     }
</style>